import { createFromIconfontCN } from '@ant-design/icons';
import IconWrapper from 'component/IconWrapper';

const IconFont = createFromIconfontCN({
  scriptUrl: window.location.origin + '/public/font_2413973_wj5icpfvepe.js'
});

export default IconWrapper(IconFont);
